import script from "./coupon.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon.vue?vue&type=script&setup=true&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=129757fc&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129757fc"]])

export default __exports__